import { getSessionForAccessInfo, checkGraphResponse } from "./GraphMain";
import { accessInfoType } from "../utils/classInfos";
import { getElementAppInfo, getViewInfoForElement } from "./graphAppInfoElementFunctions";
import { getHelperTables } from "./helper";
import { getGraphElementId } from "../utils/helper";
import store from "./StoreRoot";

export async function getViewData(
  accessInfo: accessInfoType,
  viewId: string
) {
  const sessionInfo  = await getSessionForAccessInfo(accessInfo);
  // check the info
  if (!sessionInfo || !sessionInfo.sessionId) return null;
  const {client, sessionId, fileUrl} = sessionInfo;

  // get the view info
  let viewInfo = await getViewInfoForElement(viewId, "view", sessionId, fileUrl, client);      
  if (!viewInfo) { return null }

  const tableId = getGraphElementId(viewInfo.baseElementId, viewInfo.baseElementType);
  const tableUrl = fileUrl + "/workbook/tables/" + tableId;
  const cellLimitString = "?$top="+String(store.main.limitCellCount);

  const $batch = {
    requests: [
      {
        url: tableUrl + "/headerRowRange?$select=columnCount,columnIndex,rowIndex,rowCount,address,values",
        method: "GET",
        id: "HEADER",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: tableUrl + "/range?$select=cellCount,address", //?$select=values,formulas,numberFormat,cellCount,address",
        method: "GET",
        id: "RANGE",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: tableUrl + "/rows" + cellLimitString,
        method: "GET",
        id: "ROWS",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: fileUrl + "/workbook/tables?$select=name",
        method: "GET",
        id: "TABLES",
        headers: {
          "workbook-session-id": sessionId
        }
      },
    ],
  };

  let res = await client
    .api("/$batch")
    .post($batch);

  checkGraphResponse(res, "getViewData");  
  // TABLES
  let tableHeader = res.responses[res.responses.findIndex((x) => x.id === "HEADER")];
  let tableHeaders = tableHeader.body?.values[0];
  let range = res.responses[res.responses.findIndex((x) => x.id === "RANGE")]?.body;
  let tableRows = res.responses[res.responses.findIndex((x) => x.id === "ROWS")]?.body;
  let tableTables = res.responses[res.responses.findIndex((x) => x.id === "TABLES")]?.body;
  let elementName = viewInfo.caption;
  //table info
  let tableInfo = {
    headerRowIndex: tableHeader.body?.rowIndex,
    headerColumnIndex: tableHeader.body?.columnIndex,
    headerColumnCount: tableHeader.body?.columnCount,
    headerAddress: tableHeader.body?.address,
    headerValues: tableHeader.body?.values,
    rangeAddress: range?.address,
  }
  viewInfo.tableInfo = tableInfo;
  //convert into json array
  let data = [];
  for (
    let rowIndex = 0, rowCount = tableRows?.value.length;
    rowIndex < rowCount;
    ++rowIndex
  ) {
    const tempRow = tableRows.value[rowIndex];
    if (tempRow.values) {
      const tempRowIndex = tempRow.index;
      const tempRowValues = tempRow.values[0];
      let rowObject = {};
      for (
        let colIndex = 0, colCount = tableHeaders.length;
        colIndex < colCount;
        ++colIndex
      ) {
        const colName = tableHeaders[colIndex];
        const rowValue = tempRowValues[colIndex];
        rowObject[colName] = rowValue;
      }
      rowObject["arRowIndex"] = tempRowIndex;
      data.push(rowObject);
    }
  }
  // get the table name
  tableTables?.value.forEach((tempTable) => {
    if (tempTable.id === tableId) {
      elementName = tempTable.name;
    }
  });

  // helper tables
  const helperTables = getHelperTables(tableTables?.value);
  const hasHelperTables = helperTables.length > 0;
  // get the app info
  let appInfo = await getElementAppInfo(accessInfo, viewId, "view", sessionId, fileUrl, client, helperTables);
  

  return { 
    viewId, 
    range,
    data,
    appInfo,
    accessInfo,
    hasHelperTables,
    helperTables,
    elementName,
    viewInfo
  };
}

